import { FunctionComponent } from 'react';
import styles from './PromocodeTag.module.scss';
import clsx from 'clsx';
import { faBadgePercent } from '@fortawesome/pro-regular-svg-icons/faBadgePercent';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PromocodeTagProps {
    id: number;
    name: string;
    onRemove?: () => void;
    className?: string;
}

export const PromocodeTag: FunctionComponent<PromocodeTagProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faBadgePercent}
                fontSize={13}
            />
            <span className={styles.name}>{props.name}</span>
            {props.onRemove && (
                <FontAwesomeIcon
                    icon={faTimes}
                    onClick={props.onRemove}
                    fontSize={13}
                    className={styles.removeIcon}
                />
            )}
        </div>
    );
};

export default PromocodeTag;
